import React from 'react'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import * as S from './SectionCtaCytology.styles'

const SectionCtaCytology = () => {
  const { t } = useTranslation()

  return (
    <S.Section>
      <S.Container>
        <S.ImgCol>
          <Image
            src={`${process.env.CDN_URL}/public/landingpagev2/images/content_cytology.png`}
            alt="BioAtlas Cytology Content"
            width={200}
            height={182}
            style={{ maxWidth: '100%', height: 'auto', width: 'auto' }}
            priority
          />
        </S.ImgCol>
        <S.Content>
          <S.Text
            dangerouslySetInnerHTML={{
              __html: t('landingV2.sectionCtaCytology.text')
            }}
          />
        </S.Content>
        <S.ButtonCol>
          <S.CTAButton>{t('landingV2.sectionCtaCytology.button')}</S.CTAButton>
        </S.ButtonCol>
      </S.Container>
    </S.Section>
  )
}

export default SectionCtaCytology
